import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, Input, OnChanges, Output, PLATFORM_ID, Renderer2, SimpleChange, ViewChild, OnDestroy } from '@angular/core';
import { AnalyticsService } from '@shared/utils/services';


@Component({
	selector: 'common-side-nav',
	templateUrl: './side-nav.component.html',
	styleUrls: ['./side-nav.component.scss'],
	standalone: false
})
export class SideNavComponent implements OnChanges, OnDestroy {
	@Input() modalName = 'Default Modal';
	@Input() isSidePanelToggled: boolean;
	@Input() panelBodyClass = '';
	@Input() panelContainerClass = '';
	@Input() side = 'right';
	@Input() zipConfirm;
	@Input() addFlexBox = false;
	@Input() isFormEmpty = true;

	@Output() panelEvent = new EventEmitter();

	/**
	 * @description
	 * Whether or not the panel should be displayed
	 */
	public showContent = false;

	@ViewChild('sidePanel', { static: false })
		sidenav: any;

	constructor(@Inject(PLATFORM_ID) protected platformId: any, private analyticsService: AnalyticsService, private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private eleRef: ElementRef) {}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
		if (this.sidenav !== undefined) {
			if (this.isSidePanelToggled) {
				this.panelToggle('open');
			} else {
				this.panelToggle('close');
			}
		}
	}

	ngOnDestroy(): void {
		if (this.showContent) {
			// Side nav is still open (although it may not be displaying) so we have to
			this.panelToggle('close');
		}
	}

	public panelToggle(event: string) {
		if (event === 'open') {
			this.showContent = true;

			this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
			this.renderer.addClass(this.document.body, 'side-panel-open');

			this.sendAnalyticsFor(this.modalName);

			this.panelEvent.emit({ opened: true });
			this.eleRef.nativeElement.focus();
		} else {
			/*
			 * Closed
			 */
			this.showContent = false;

			this.renderer.setStyle(this.document.body, 'overflow', 'visible');
			this.renderer.removeClass(this.document.body, 'side-panel-open');

			this.panelEvent.emit({ opened: false });
			this.eleRef.nativeElement.blur();
		}
	}

	public sendAnalyticsFor(name: string) {
		/*
		 * Analytics Event
		 */
		// Set the modal name
		this.analyticsService.setModalName(name);

		// Set the Analytics event type
		this.analyticsService.setType('event', 'ModalOpen');

		// Trigger the Analytics update
		this.analyticsService.triggerAnalyticsEvent('reporting:update');
	}
}
